module.exports = __webpack_public_path__ + "static/media/17-1.6d48bf55.mp3";